<script setup async>
import { ref, watch } from "vue";
import { debounce } from 'lodash';

const props = defineProps({
    date_from: String,
    date_to: String,
    status: String,
    office: String,
    offices: Array,
    client: String,
    clients: Array,
});

const resetFilters = () => {
    // Resetting each property to its default value
    props.date_from = null;
    props.date_to = null;
    props.status = null;
    props.office = null;
    selectedClientObject.value = null;

    // Emitting the updated values to the parent
    emit('update:date_from', null);
    emit('update:date_to', null);
    emit('update:status', null);
    emit('update:office', null);
    emit('update:client', null);  // Assuming 'client' is the prop for the v-select, adjust as needed
};

const emit = defineEmits(['update:client']);

const selectedClientObject = ref({ name: props.client });  // Assuming default is just a name
const clientOptions = props.clients;

watch(selectedClientObject, (newVal, oldVal) => {
  if (newVal !== oldVal && newVal) {
    // Emit to parent and make POST request when the model changes
    emit('update:client', newVal.name);
    // TODO: Make your POST request here using newVal
  }
});
</script>
<template>
    <div>
        <div class="w-full block lg:flex gap-3 lg:justify-between">
            <div class="lg:flex lg:gap-1 w-full items-center mr-4">
                <div class="w-full mt-auto">
                    <label for="invoiced_at" class="text-xs text-gray-700">
                        Invoiced At
                    </label>
                    <input
                        id="invoiced_at"
                        type="date"
                        class="flex-grow-1 mt-1 block w-full
                        border border-gray-300 rounded-md shadow-sm py-2 px-3
                        focus:outline-none focus:ring-gray-900
                        focus:border-gray-900 sm:text-sm"
                        autocomplete="date_from"
                        :value="props?.date_from"
                        @change="$emit('update:date_from', $event.target.value)"
                    />
                </div>
                <div class="w-full mt-auto">
                    <label for="due_at" class="text-xs text-gray-700">
                        Due At
                    </label>
                    <input
                        id="due_at"
                        type="date"
                        class="flex-grow-1 mt-1 block w-full
                        border border-gray-300 rounded-md shadow-sm py-2 px-3
                        focus:outline-none focus:ring-gray-900
                        focus:border-gray-900 sm:text-sm"
                        autocomplete="date_to"
                        :value="props?.date_to"
                        @change="$emit('update:date_to', $event.target.value)"
                    />
                </div>
                <div class="w-full mt-auto">
                    <label for="status" class="text-xs text-gray-700">
                        Status
                    </label>
                    <select
                        id="status"
                        class="flex-grow-1 mt-1 block w-full
                        border border-gray-300 rounded-md shadow-sm py-2 px-3
                        focus:outline-none focus:ring-gray-900"
                        v-model="props.status"
                        @change="$emit('update:status', $event.target.value)"
                    >
                        <option value selected>Status</option>
                        <option value="Paid">Paid</option>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Sent">Sent</option>
                    </select>
                </div>
                <div class="w-full mt-auto">
                    <label for="office" class="text-xs text-gray-700">
                        Office
                    </label>
                    <select
                        id="office"
                        class="flex-grow-1 mt-1 block w-full
                        border border-gray-300 rounded-md shadow-sm py-2 px-3
                        focus:outline-none focus:ring-gray-900"
                        v-model="props.office"
                        @change="$emit('update:office', $event.target.value)"
                    >
                        <option value selected>Office</option>
                        <option v-for="office in offices" :key="office" :value="office.name">{{ office.name }}</option>
                    </select>
                </div>
                <div class="w-full mt-auto">
                    <label for="client_id" class="block text-sm font-medium text-gray-700">Client</label>
                    <v-select
                        id="client"
                        class="bg-white"
                        v-model="selectedClientObject"
                        :options="clientOptions"
                        label="name"
                        placeholder="Clients"
                        :reduce="option => option"
                    ></v-select>
                </div>
                <div class="w-1/3 text-right mt-auto">
                    <button
                        @click="resetFilters"
                        class="text-sm text-gray-500 hover:text-gray-700"
                    >
                        Reset Filters
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
